import { useEffect, useState, createRef } from 'react';
import ErrorMessage from '../ErrorMessage';
import InlineSVG from 'react-inlinesvg';

const searchIcon = '/assets/icons/search.svg';
const iconPath = `${process.env.PUBLIC_URL}${searchIcon}`;

function Search(props) {
	const autocompleteInput = createRef();
	const [error, setError] = useState(false);
	const [googleIsLoaded, setGoogleIsLoaded] = useState(false);
	const [streetAddress2, setStreetAddress2] = useState('');
	const [property, setProperty] = useState(null);

	function handleKeyUp(e) {
		if (e.key === 'Enter') {
			handleOnSubmit(e);
		}
	}

	useEffect(() => {
		if (googleIsLoaded) {
			initAutocomplete();
		} else {
			checkGoogle();
		}

		window.addEventListener('keyup', handleKeyUp);

		return () => window.removeEventListener('keyup', handleKeyUp);
	}, [handleKeyUp]);

	function handleOnSubmit(e) {
		e.preventDefault();

		const address = mapToAddress(property);

		if (!hasAddressFields(address)) {
			setError(true);
			return;
		}

		setError(false);
		props.onSubmit(address);
	}

	function checkGoogle() {
		setInterval(() => {
			if (window.google) {
				setGoogleIsLoaded(true);
				clearInterval(checkGoogle);
			}
		}, 100);
	}

	function initAutocomplete() {
		const { google } = window;

		const autocomplete = new google.maps.places.Autocomplete(
			autocompleteInput.current
		);

		autocomplete.addListener('place_changed', () => {
			const place = autocomplete.getPlace();
			if (place?.address_components) {
				setProperty(place.address_components);
			}
		});
	}

	function mapToAddress(addressList) {
		if (!addressList?.length) {
			return null;
		}

		const addressObject = {};

		addressObject.streetAddress2 = streetAddress2 || null;

		addressList.forEach((item) => {
			switch (item.types[0]) {
				case 'street_number':
					addressObject.streetAddress1 = item.long_name;
					break;
				case 'route':
					if (addressObject.streetAddress1) {
						addressObject.streetAddress1 += ` ${item.long_name}`;
					} else {
						addressObject.streetAddress1 = item.long_name;
					}
					break;
				case 'locality':
					addressObject.city = item.long_name;
					break;
				case 'administrative_area_level_1':
					addressObject.state = item.short_name;
					break;
				case 'postal_code':
					addressObject.postalCode = item.long_name;
					break;
				case 'country':
					addressObject.country = item.short_name;
					break;
				default:
					break;
			}
		});

		return addressObject;
	}

	function hasAddressFields(address) {
		if (!address) {
			return false;
		}

		if (!address.hasOwnProperty('streetAddress1')) {
			return false;
		}

		if (!address.hasOwnProperty('city')) {
			return false;
		}

		if (!address.hasOwnProperty('postalCode')) {
			return false;
		}

		if (!address.hasOwnProperty('country')) {
			return false;
		}

		return true;
	}

	return (
		<section>
			<header className='h-ms-4 my-6 mx-auto w-full'>
				What Is Your Home Worth?
			</header>
			<div className='app-container'>
				<form className='form card card-border p-4' onSubmit={handleOnSubmit}>
					<label className='mb-4 uppercase h-ms-1' htmlFor='search'>
						See Your Home’s Value Today
					</label>
					<div className='flex justify-between justify-items-center'>
						<input
							className='input input-search mr-4'
							placeholder='ENTER ADDRESS'
							type='text'
							name='search'
							id='search'
							ref={autocompleteInput}
						/>

						<input
							className='border w-14 mr-2 text-center'
							onChange={(e) => setStreetAddress2(e.target.value)}
							placeholder='UNIT'
							type='text'
							value={streetAddress2}
						/>
						<button className='button button-icon' type='submit'>
							<i className='icon icon-fill-fg'>
								<InlineSVG src={iconPath} />
							</i>
						</button>
					</div>
				</form>

				{error ? (
					<ErrorMessage
						heading='Error'
						message='Please enter a valid address and try again.'
					/>
				) : null}
			</div>
		</section>
	);
}

export default Search;
